export const MIN_REGISTRATION_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;

export function isPlausibleEmail(value) {
  const email = String(value || "").trim().toLowerCase();
  if (!email || email.length > 254 || /\s/.test(email)) return false;
  const parts = email.split("@");
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  if (!local || local.length > 64 || local.startsWith(".") || local.endsWith(".") || local.includes("..")) return false;
  if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(local)) return false;
  const labels = domain.split(".");
  if (labels.length < 2 || labels.some((label) => !label || label.length > 63 || !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(label))) return false;
  return /^(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/i.test(labels.at(-1));
}

export function registrationFieldError({
  name,
  surname,
  birthDate,
  username,
  email,
  password,
  socialRegistration = false,
} = {}) {
  const cleanName = String(name || "").trim();
  const cleanSurname = String(surname || "").trim();
  if (!cleanName) return "name_required";
  if (Array.from(cleanName).length < 3) return "name_min";
  if (!cleanSurname) return "surname_required";
  if (Array.from(cleanSurname).length < 2) return "surname_min";
  if (!String(birthDate || "").trim()) return "birthDate_required";
  if (!String(username || "").trim()) return "username_required";
  if (!isPlausibleEmail(email)) return "email_invalid";
  if (!socialRegistration) {
    const length = String(password || "").length;
    if (length < MIN_REGISTRATION_PASSWORD_LENGTH || length > MAX_PASSWORD_LENGTH) return "password_invalid";
  }
  return "";
}
